import styled from 'styled-components'

const ModalDescription = styled.div`
	font-size: 16px;
`

export default ModalDescription